export const GET_ALL_CUSTOMTABLES_BY_USER_LOADING = "GET_ALL_CUSTOMTABLES_BY_USER_LOADING"
export const GET_ALL_CUSTOMTABLES_BY_USER_SUCCESS = "GET_ALL_CUSTOMTABLES_BY_USER_SUCCESS"
export const GET_ALL_CUSTOMTABLES_BY_USER_FAILED = "GET_ALL_CUSTOMTABLES_BY_USER_FAILED"
export const GET_ALL_CUSTOMTABLES_BY_USER_EMPTY = "GET_ALL_CUSTOMTABLES_BY_USER_EMPTY"

export const GET_ALL_CUSTOMTABLES_OF_PROJECT = 'GET_ALL_CUSTOMTABLES_OF_PROJECT';
export const GET_ALL_CUSTOMTABLES_OF_PROJECT_SUCCESS = 'GET_ALL_CUSTOMTABLES_OF_PROJECT_SUCCESS';
export const GET_ALL_CUSTOMTABLES_OF_PROJECT_FAILED = 'GET_ALL_CUSTOMTABLES_OF_PROJECT_FAILED';
